import api from './api';

const d = (r) => r.data;

export const esignAPI = {
  my: () => api.get('/api/esign/my').then(d),
  draftBlob: (id) => api.get(`/api/esign/letters/${id}/draft.pdf`, { responseType: 'blob' }).then(d),
  signedBlob: (id) => api.get(`/api/esign/letters/${id}/signed.pdf`, { responseType: 'blob' }).then(d),
  evidenceBlob: (id, kind) => api.get(`/api/esign/letters/${id}/evidence/${kind}`, { responseType: 'blob' }).then(d),
  start: (id, body) => api.post(`/api/esign/letters/${id}/start`, body).then(d),
  status: (id) => api.get(`/api/esign/letters/${id}/status`).then(d),
  list: (filter) => api.get('/api/esign/letters', { params: { filter } }).then(d),
  clientLetters: (cid) => api.get(`/api/esign/clients/${cid}/letters`).then(d),
  send: (cid, body) => api.post(`/api/esign/clients/${cid}/send`, body).then(d),
  sendPreview: (cid, body) => api.post(`/api/esign/clients/${cid}/send-preview`, body).then(d),
  sendPreviewBlob: (cid, body) => api.post(`/api/esign/clients/${cid}/send-preview.pdf`, body, { responseType: 'blob' }).then(d),
  issue: (id) => api.post(`/api/esign/letters/${id}/issue`).then(d),
  remind: (id) => api.post(`/api/esign/letters/${id}/remind`).then(d),
  resendInvite: (id) => api.post(`/api/esign/letters/${id}/resend-invite`).then(d),
  signingLink: (id) => api.post(`/api/esign/letters/${id}/signing-link`).then(d),
  resync: (id) => api.post(`/api/esign/letters/${id}/resync`).then(d),
  cancel: (id, body) => api.post(`/api/esign/letters/${id}/cancel`, body).then(d),
  override: (id, reason) => api.post(`/api/esign/letters/${id}/override-onboarding`, { reason }).then(d),
  settings: () => api.get('/api/esign/settings').then(d),
  saveSettings: (body) => api.put('/api/esign/settings', body).then(d),
  testConnection: () => api.post('/api/esign/settings/test-connection').then(d),
  testWorkflow: (email) => api.post('/api/esign/settings/test-workflow', { email }).then(d),
  templates: () => api.get('/api/esign/templates').then(d),
  createTemplate: (fd) => api.post('/api/esign/templates', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(d),
  addVersion: (key, fd) => api.post(`/api/esign/templates/${key}/versions`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(d),
  approveVersion: (key, v) => api.post(`/api/esign/templates/${key}/versions/${v}/approve`).then(d),
  configTemplate: (key, body) => api.put(`/api/esign/templates/${key}/config`, body).then(d),
  previewBlob: (key) => api.get(`/api/esign/templates/${key}/preview`, { responseType: 'blob' }).then(d),
  versionBlob: (key, v) => api.get(`/api/esign/templates/${key}/versions/${v}/file`, { responseType: 'blob' }).then(d),
};

export const ESIGN_LABELS = {
  draft: 'Draft', form_completed: 'Form completed', letter_generating: 'Letter generating', ready_for_review: 'Ready for review',
  awaiting_signature: 'Awaiting signature', partially_signed: 'Partially signed', signed: 'Signed', declined: 'Declined', expired: 'Expired',
  cancelled: 'Cancelled', error: 'Error', onboarding_completed: 'Onboarding completed',
};

export const ESIGN_COLORS = {
  signed: 'bg-emerald-100 text-emerald-800', onboarding_completed: 'bg-emerald-100 text-emerald-800', declined: 'bg-red-100 text-red-800',
  expired: 'bg-amber-100 text-amber-800', cancelled: 'bg-muted text-muted-foreground', error: 'bg-red-100 text-red-800',
  partially_signed: 'bg-sky-100 text-sky-800', awaiting_signature: 'bg-sky-100 text-sky-800',
};

// Auto-issued letters go straight to awaiting_signature; until the client consents they read as one combined step.
export const esignLabel = (status, consented) => (['ready_for_review', 'awaiting_signature'].includes(status) && !consented ? 'Ready for review & signing' : ESIGN_LABELS[status] || status);

export const errMsg = (e) => {
  const det = e?.response?.data?.detail;
  return Array.isArray(det) ? det.map((x) => x.msg).join('; ') : det || e?.message || 'Something went wrong';
};

export const saveBlob = (blob, name) => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); };
